import { MapViewProvider } from 'contexts/MapViewContext';
import FloatingWindowsSystem from '../../FloatingWindowsSystem';
import Map from '../../Map';
import { FloatingWindowsProvider } from '../../../../../../../../../contexts/FloatingWindowsContext';
import { LayerViewProvider } from '../../../../../../../../../contexts/LayerViewContext';

function LayerView() {
  return (
    <FloatingWindowsProvider>
      <LayerViewProvider>
        <MapViewProvider index={0}>
          <FloatingWindowsSystem mode="layer" />
          <Map />
        </MapViewProvider>
      </LayerViewProvider>
    </FloatingWindowsProvider>
  );
}

export default LayerView;
